const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "https://api-xjjsmbw66q-uc.a.run.app" // Use production for development too
    : "https://api-xjjsmbw66q-uc.a.run.app";

export default API_BASE_URL;
